import React from 'react'
import { Accordion } from 'routes/components/Shared'
import { faqArray } from './faqArray'

export const PricingFAQ = () => {
  return (
    <div className='pricing-faq'>
      <div className='pricing-faq__body'>
        <h2 className='page__title pricing-faq__title'>FAQ</h2>

        <div className='pricing-faq__items'>
          <Accordion array={faqArray} />
        </div>
      </div>
    </div>
  )
}
